import React from 'react';

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

const BudgetCategoryChart = ({ categories }) => {
  const total = categories?.reduce((sum, c) => sum + c?.budget, 0) || 1;

  return (
    <div className="bg-card rounded-xl border border-border shadow-sm p-6">
      <h3 className="font-semibold text-foreground mb-4">Budget by Category</h3>
      <div className="space-y-3">
        {categories?.map((cat, idx) => {
          const pct = Math.round((cat?.budget / total) * 100);
          const actualPct = Math.round((cat?.actual / cat?.budget) * 100);
          const isOver = cat?.actual > cat?.budget;
          return (
            <div key={cat?.name}>
              <div className="flex items-center justify-between text-sm mb-1">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: COLORS?.[idx % COLORS?.length] }} />
                  <span className="font-medium text-foreground">{cat?.name}</span>
                </div>
                <div className="flex items-center gap-3 text-xs">
                  <span className="text-muted-foreground">Budget: £{(cat?.budget / 1000)?.toFixed(0)}k</span>
                  <span className={`font-semibold ${isOver ? 'text-red-600' : 'text-emerald-600'}`}>
                    Actual: £{(cat?.actual / 1000)?.toFixed(0)}k
                  </span>
                  <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${
                    isOver ? 'bg-red-100 text-red-700' : 'bg-emerald-100 text-emerald-700'
                  }`}>{isOver ? `+${actualPct - 100}%` : `${actualPct}%`}</span>
                </div>
              </div>
              <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
                <div
                  className="h-2 rounded-full transition-all"
                  style={{
                    width: `${Math.min(actualPct, 100)}%`,
                    backgroundColor: isOver ? '#ef4444' : COLORS?.[idx % COLORS?.length],
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BudgetCategoryChart;
